<template>
  <div class="app-wrapper">
    <Header/>
    <div class="app-container container">
      <router-view class="app-main"/>
      <Right class="hidden-xs"/>
    </div>
    <Footer/>
    <el-backtop :bottom="80"></el-backtop>
  </div>
</template>

<script>
import Header from "@/layout/components/header.vue";
import Right from "@/layout/components/right.vue";
import Footer from "./components/footer.vue";

export default {
  name: "layout",
  components: { Header, Right,Footer},
}
</script>


<style lang="scss">
.app-wrapper {
  background-color: --color(--p-bg-color);
  min-height: 100vh;
  padding-top: 60px;

  @media(max-width: 767px) {
    background-color: --color(--p-white);
  }

  .app-container {
    display: flex;

    @media(max-width: 767px) {
      padding: 0;
    }

    .app-main {
      flex: 1;
    }

    .app-right {
      width: 300px;
      margin: 20px 0;
      margin-left: 20px;
    }
  }
}

.lazy-image[lazy=loading] {
}
.lazy-image[lazy=loaded] {
  animation: fade-in 0.3s ease-in-out;
}
@keyframes fade-in {
  from {
    filter: blur(10px);
  }
  to {
    filter: blur(0px);
  }
}
</style>
